import React, { useEffect, useMemo, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { textToMarkdown } from "@root/utils/streaming";

interface MarkdownContentProps {
  content: string;
  p?: number;
  onLinkClick?: (text: string, url: string) => void;
  sources?: any;
  isMultiAnswer?: boolean;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  p = "0",
  onLinkClick,
  isMultiAnswer = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  // Memoize markdown conversion since it's relatively heavy and content can update rapidly
  const html = useMemo(() => textToMarkdown(content), [content]);

  useEffect(() => {
    if (!onLinkClick || !containerRef.current) return;

    const handleLinkClick = (event: Event) => {
      const target = event.target as HTMLElement;
      const link = target.closest("a");
      if (link) {
        const text = link.textContent || "";
        const url = link.getAttribute("href") || "";
        onLinkClick?.(text, url);
      }
    };

    const container = containerRef.current;
    container.addEventListener("click", handleLinkClick);

    return () => {
      container.removeEventListener("click", handleLinkClick);
    };
  }, [onLinkClick]);

  return (
    <Box p={p}>
      <div
        ref={containerRef}
        className={
          isMultiAnswer
            ? "primary-markdown multi-answer-markdown"
            : "primary-markdown"
        }
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Box>
  );
};

export default MarkdownContent;
